import { Product } from "@b2bportal/purchase-api";
import {
  ParentState,
  cartHelpers,
  ContactSelectors,
} from "@hopper-b2b/checkout";
import { assign } from "xstate";
import { setContextWithKey } from "../../../helpers";
import type { ActivitiesContext } from "./types";

export const ActivitiesActions = {
  addActivityProduct: assign((context: ActivitiesContext, _event: unknown) => {
    const activitiesShop = context[ParentState.activitiesShop];
    const { opaqueShoppedProduct } = activitiesShop ?? {};

    const params = {
      quoteRequest: {
        value: opaqueShoppedProduct,
      },
    };

    const activityProduct = {
      type: Product.Activities,
      value: params,
    };

    const ctxWithActivity = cartHelpers.addQuoteProduct(
      activityProduct,
      context
    );

    const contactInformation = ContactSelectors.getContactInformation({
      context,
    });

    return setContextWithKey(
      ctxWithActivity,
      `${ParentState.cartQuote}.customerEmail`,
      contactInformation?.email
    );
  }),
};
